import axios from "axios";

export const axiosCancelTokenMixin = {
  data: () => ({
    actm: {
      cancelToken: null
    }
  }),
  mounted() {
    this.actm.cancelToken = axios.CancelToken;
  },
  methods: {
    actmGenerateToken(token) {
      this.actmCancelToken(token);
      return this.actm.cancelToken.source();
    },
    actmCancelToken(token) {
      if (token) token.cancel();
    }
  }
};



// WEBPACK FOOTER //
// ./src/mixins/axiosCancelTokenMixin.js